import { render, staticRenderFns } from "./trade_withdraw.vue?vue&type=template&id=3da5cfb4&"
import script from "./trade_withdraw.vue?vue&type=script&lang=js&"
export * from "./trade_withdraw.vue?vue&type=script&lang=js&"
import style0 from "./trade_withdraw.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports